var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 34",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#crown_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.034 11.966-2.498 9.076H8.468l-2.502-9.09.32-.083 5.61 3.846 4.474-6.951h.264l4.475 6.951 5.593-3.835.332.086Z",
    fill: "url(#crown_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.468 24.413c0 .455.368.823.823.823h14.422a.823.823 0 0 0 .823-.823v-2.262H8.468v2.262Z",
    fill: "url(#crown_svg__c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown_svg__b",
    x1: 27.893,
    y1: 20.882,
    x2: 8.597,
    y2: 20.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFC46B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "crown_svg__c",
    x1: 25.191,
    y1: 25.196,
    x2: 10.484,
    y2: 24.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B17316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFC46B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F90"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "crown_svg__a",
    x: 0.408,
    y: 0.908,
    width: 32.185,
    height: 32.185,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.546
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_12538"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1_12538",
    result: "shape"
  })))));
};
export default SvgCrown;